const INTERNAL_WALK_IN_EMAIL_DOMAIN = '@sessionmonkey.local';

export const isInternalWalkInContactEmail = (email?: string | null) =>
  String(email || '').trim().toLowerCase().endsWith(INTERNAL_WALK_IN_EMAIL_DOMAIN);

export const getDisplayContactEmail = (email?: string | null) => {
  const normalized = String(email || '').trim();
  if (!normalized || isInternalWalkInContactEmail(normalized)) {
    return 'No contact details';
  }

  return normalized;
};

export const getDisplayContactPhone = (email?: string | null, phone?: string | null) => {
  const normalizedPhone = String(phone || '').trim();
  if (normalizedPhone) {
    return normalizedPhone;
  }

  return isInternalWalkInContactEmail(email) || !String(email || '').trim() ? '' : '-';
};
